/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/anchor-has-content */
import { useRef, useState, useEffect } from 'react';
import { FaAngleRight } from 'react-icons/fa';

import electronicaImg from './assets/pngs/electronica.png';
import miBankitoImg from './assets/pngs/mi_bankito.png';
import multiInversionImg from './assets/pngs/multi_inversion.png';
import multiRentableImg from './assets/pngs/multi_rentable.png';
import { houndService } from './services/index';

import './App.css';

const DEFAULT_ACCOUNTS = [
  { id: 'MB_Multi_Inversion', title: 'Multi Inversión' },
  { id: 'MB_Multi_Rentable', title: 'Multi Rentable' },
  { id: 'MB_Electronica', title: 'Electrónica' },
  { id: 'MB_Mibankito', title: 'Mi Bankito' },
  { id: 'MB_Simplificada', title: 'Simplificada' },
];

const DEFAULT_ENV = [
  { id: 'beta', title: 'Beta', cls: 'beta-cls' },
  { id: 'producción', title: 'Producción', cls: 'prod-cls' },
];

const MiBancoDemo = () => {
  let mbRef = useRef(null);
  let qrRef = useRef(null);
  let typeAccountRef = useRef(null);
  let titleAccountRef = useRef(null);
  let inputEmailRef = useRef(null);
  let emailNameRef = useRef(null);
  let callToActionRef = useRef(null);
  let errorEmailRef = useRef(null);
  let error2EmailRef = useRef(null);
  let btnActionRef = useRef(null);
  let headerRef = useRef(null);
  let contentRef = useRef(null);
  let processingRef = useRef(null);
  let successedRef = useRef(null);
  const [enviorement, setEnviorement] = useState(true);
  const [typeAccount, setTypeAccount] = useState(DEFAULT_ACCOUNTS[0].id);
  const [open, setOpen] = useState(false);

  const Modal = ({ isOpen, closeModal, children }) => {
    if (!isOpen) {
      return null;
    }

    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <span className="close-button" onClick={closeModal}>
            &times;
          </span>
          {children}
        </div>
      </div>
    );
  };

  const toogleModal = () => {
    setOpen((o) => !o);
  };

  const redirectToMB = () => {
    mbRef.current.click();
  };

  const toogleEnviorement = () => {
    setEnviorement((e) => !e);
  };

  useEffect(() => {
    if (enviorement !== true) {
      toogleModal();
    }
  }, [enviorement]);

  // const checkEmail = () => {
  //   const isValid = !verifyEmail(inputEmailRef.current.value);
  //   btnActionRef.current.disabled = isValid;
  //   if (isValid) {
  //     errorEmailRef.current.style.display = 'flex';
  //     return true;
  //   } else {
  //     errorEmailRef.current.style.display = 'none';
  //     return false;
  //   }
  // };

  const resetEmail = () => {
    errorEmailRef.current.style.display = 'none';
    error2EmailRef.current.style.display = 'none';
  };

  const verifyEmail = (entry) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(entry);
  };

  useEffect(() => {
    if (inputEmailRef.current.value !== '') {
      successedRef.current.style.display = 'none';
      processingRef.current.style.display = 'none';
      const isValid = !verifyEmail(inputEmailRef.current.value);
      if (isValid) {
        errorEmailRef.current.style.display = 'none';
      } else {
        errorEmailRef.current.style.display = 'flex';
      }
    }
    // error2EmailRef.current.style.display = 'flex';
  }, []);

  useEffect(() => {
    // btnActionRef.current.disabled = true;
    inputEmailRef.current.value = '';
    processingRef.current.style.display = 'none';
    contentRef.current.style.display = 'flex';
    headerRef.current.style.display = 'flex';
    callToActionRef.current.style.display = 'flex';
    successedRef.current.style.display = 'none';
    resetEmail();
    const displayAccount = () => {
      let title;
      switch (typeAccount) {
        case DEFAULT_ACCOUNTS[0].id:
          qrRef.current.src = multiInversionImg;
          title = `Cuenta de ahorro ${DEFAULT_ACCOUNTS[0].title}`;
          break;

        case DEFAULT_ACCOUNTS[1].id:
          qrRef.current.src = multiRentableImg;
          title = `Cuenta de ahorro ${DEFAULT_ACCOUNTS[1].title}`;
          break;

        case DEFAULT_ACCOUNTS[2].id:
          qrRef.current.src = electronicaImg;
          title = `Cuenta de ahorro ${DEFAULT_ACCOUNTS[2].title}`;
          break;

        case DEFAULT_ACCOUNTS[3].id:
          qrRef.current.src = miBankitoImg;
          title = `Cuenta de ahorro ${DEFAULT_ACCOUNTS[3].title}`;

          break;
        case DEFAULT_ACCOUNTS[4].id:
          qrRef.current.src = miBankitoImg;
          title = `Cuenta ${DEFAULT_ACCOUNTS[4].title}`;

          break;
        default:
          qrRef.current.src = multiInversionImg;
          title = `Cuenta de ahorro ${DEFAULT_ACCOUNTS[0].title}`;
          break;
      }
      typeAccountRef.current.innerText = title;
      titleAccountRef.current.innerText = title;
    };
    displayAccount();
  }, [typeAccount]);

  const goToHome = () => {
    error2EmailRef.current.style.display = 'none';
    contentRef.current.style.display = 'flex';
    headerRef.current.style.display = 'flex';
    successedRef.current.style.display = 'none';
    emailNameRef.current.innerText = '';
    inputEmailRef.current.value = '';
    callToActionRef.current.style.display = 'flex';
  };

  const getTitle = () => {
    switch (typeAccount) {
      case DEFAULT_ACCOUNTS[0].id:
        return 'Multi Inversión';

      case DEFAULT_ACCOUNTS[1].id:
        return 'Multi Rentable';

      case DEFAULT_ACCOUNTS[2].id:
        return 'Electrónica';

      case DEFAULT_ACCOUNTS[3].id:
        return 'Mi Bankito';

      case DEFAULT_ACCOUNTS[4].id:
        return 'Cuenta Simplificada';

      default:
        return 'Multi Inversión';
    }
  };

  const handleSubmit = async () => {
    // if (checkEmail()) {
    //   return;
    // }
    processingRef.current.style.display = 'flex';
    contentRef.current.style.display = 'none';
    successedRef.current.style.display = 'none';
    headerRef.current.style.display = 'none';

    const payload = {
      'type-account': typeAccount,
      'type-title': getTitle(),
      Human: inputEmailRef.current.value,
    };
    const result = await houndService.postOpenAccountMB(payload, enviorement);
    console.log('success', result);
    setTimeout(() => {
      processingRef.current.style.display = 'none';
      if (result) {
        error2EmailRef.current.style.display = 'none';
        contentRef.current.style.display = 'none';
        successedRef.current.style.display = 'flex';
        emailNameRef.current.innerText = inputEmailRef.current.value;
      } else {
        error2EmailRef.current.style.display = 'flex';
        contentRef.current.style.display = 'flex';
        headerRef.current.style.display = 'flex';
        successedRef.current.style.display = 'none';
        emailNameRef.current.innerText = '';
        callToActionRef.current.style.display = 'none';
      }
    }, 1000);
  };

  // const handleSubmitLineal = async () => {
  //   // if (checkEmail()) {
  //   //   return;
  //   // }
  //   processingRef.current.style.display = 'flex';
  //   contentRef.current.style.display = 'none';
  //   successedRef.current.style.display = 'none';
  //   headerRef.current.style.display = 'none';

  //   const payload = {
  //     'type-account': typeAccount,
  //     Human: inputEmailRef.current.value,
  //   };
  //   const { success } = await houndService.postOpenAccountMB(payload, true);
  //   setTimeout(() => {
  //     processingRef.current.style.display = 'none';
  //     if (success) {
  //       error2EmailRef.current.style.display = 'none';
  //       contentRef.current.style.display = 'none';
  //       successedRef.current.style.display = 'flex';
  //       emailNameRef.current.innerText = inputEmailRef.current.value;
  //     } else {
  //       error2EmailRef.current.style.display = 'flex';
  //       contentRef.current.style.display = 'flex';
  //       headerRef.current.style.display = 'flex';
  //       successedRef.current.style.display = 'none';
  //       emailNameRef.current.innerText = '';
  //       callToActionRef.current.style.display = 'none';
  //     }
  //   }, 1500);
  // };

  const cancel = () => {
    toogleModal();
    toogleEnviorement();
  };

  return (
    <div className="App">
      <header ref={headerRef} className="App-header">
        <img className="img-main" src="http://cdn.houndsoftware.net/mib/MB-main.svg" alt="" />
      </header>
      <div ref={contentRef} className="App-body">
        <Modal isOpen={open} closeModal={cancel}>
          <h2 className="bounce">¿Está seguro de que desea cambiar al ambiente de producción?</h2>
          <div className="flexes">
            <button type="button" className="btn-cancel" onClick={cancel}>
              Cancelar
            </button>
            <button type="button" className="btn-tercero" onClick={toogleModal}>
              Cambiar ambiente
            </button>
          </div>
        </Modal>
        <div className="constrainst-wrapper">
          <div className="controller-wrapper">
            <div className="flex-column">
              <div className="flex-column">
                <p className="cases-txt">Ambiente</p>
                <button
                  type="button"
                  className={`btn-env ${
                    enviorement === true ? DEFAULT_ENV[0].cls : DEFAULT_ENV[1].cls
                  }`}
                  onClick={toogleEnviorement}
                >
                  {enviorement ? DEFAULT_ENV[0].title : DEFAULT_ENV[1].title}
                </button>
              </div>
              <div className="flex-column">
                <p className="cases-txt">Casos</p>
                <div className="flex-btns">
                  <button
                    type="button"
                    className={`btn-seconday ${
                      typeAccount === DEFAULT_ACCOUNTS[0].id ? 'active' : ''
                    }`}
                    onClick={() => setTypeAccount(DEFAULT_ACCOUNTS[0].id)}
                  >
                    1
                  </button>
                  <button
                    type="button"
                    className={`btn-seconday ${
                      typeAccount === DEFAULT_ACCOUNTS[1].id ? 'active' : ''
                    }`}
                    onClick={() => setTypeAccount(DEFAULT_ACCOUNTS[1].id)}
                  >
                    2
                  </button>
                  <button
                    type="button"
                    className={`btn-seconday ${
                      typeAccount === DEFAULT_ACCOUNTS[2].id ? 'active' : ''
                    }`}
                    onClick={() => setTypeAccount(DEFAULT_ACCOUNTS[2].id)}
                  >
                    3
                  </button>
                  <button
                    type="button"
                    className={`btn-seconday ${
                      typeAccount === DEFAULT_ACCOUNTS[3].id ? 'active' : ''
                    }`}
                    onClick={() => setTypeAccount(DEFAULT_ACCOUNTS[3].id)}
                  >
                    4
                  </button>
                  <button
                    type="button"
                    className={`btn-seconday ${
                      typeAccount === DEFAULT_ACCOUNTS[4].id ? 'active' : ''
                    }`}
                    onClick={() => setTypeAccount(DEFAULT_ACCOUNTS[4].id)}
                  >
                    5
                  </button>
                </div>
              </div>
              <div className="flex-btns2 bounce">
                <h2 className="pwr-hound">Powered by</h2>
                <img
                  className="img-logo"
                  src="http://cdn.houndsoftware.net/assetstmp/hound-white.png"
                ></img>
              </div>
            </div>
          </div>
        </div>
        <button onClick={redirectToMB} type="button" className="App-navigator">
          <p className={'blue'}>Inicio</p>
          <a ref={mbRef} className="goto" href="https://mibanco.com.sv/"></a>
          <FaAngleRight className="gray" size={14} />
          <p className={'blue'}>Depósitos</p>
          <FaAngleRight className="gray" size={14} />
          <p ref={typeAccountRef}>Cuenta de ahorro Multi Inversión</p>
        </button>
        <h1 className="bounce" ref={titleAccountRef}>
          Crear cuenta de ahorro <b>Multi Inversión</b>
        </h1>
        <p className="sub-header">
          Complete un formulario y solicite su cuenta de ahorro fácil y rápida
        </p>
        <div className="info-wrapper">
          <div className="info-general">
            <p className="intro-text">
              Estás a unos minutos de completar tu apertura. Para que el proceso sea exitoso, asegúrate de cumplir con lo siguiente:
            </p>

            <h3 className="section-title">¿Quiénes pueden abrir esta cuenta?</h3>
            <ul className="list-constraints">
              <li>Mayores de 18 años.</li>
            </ul>

            <h3 className="section-title">Antes de empezar, asegúrate de tener:</h3>
            <ul className="list-constraints">
              <li>Conexión estable a internet.</li>
              <li>Cámara activa en este dispositivo (la usaremos para validar tu identidad).</li>
              <li>Documento de identidad vigente (DUI).</li>
            </ul>

            <h3 className="section-title">Requisitos adicionales según tu perfil:</h3>
            <ul className="list-constraints">

              <li><b>Si tus ingresos son mayores a $2,000.00:</b> Ten a la mano tu constancia de ingresos o declaración de impuestos digitalizada.</li>
            </ul>

            <h3 className="section-title">Un par de consejos:</h3>
            <ul className="list-constraints">
              <li>Busca un lugar con buena iluminación para tus fotos.</li>
              <li>Ten listos tus datos personales y documentos de identidad vigentes.</li>
            </ul>
          </div>
          <div className="avatar info-mobile">
            <h2 className="sub-title-mobile">¿No está en un dispositivo con cámara?</h2>
            <img
              ref={qrRef}
              src={electronicaImg}
              className="qr"
              alt="change to a device with a camera"
            />
          </div>
        </div>
        <div ref={callToActionRef} className="callToAction-wrapper">
          <div className="row">
            <input
              ref={inputEmailRef}
              type="email"
              className="input-class"
              placeholder="Escriba su correo electrónico"
              // onBlur={checkEmail}
              // onChange={resetEmail}
            />
            <p ref={errorEmailRef} className="error-txt bounce">
              Correo electrónico incorrecto
            </p>
          </div>
          <button ref={btnActionRef} type="button" className="btn-primary" onClick={handleSubmit}>
            Ir a crear cuenta
          </button>
          {/* <button
            disabled={
              typeAccount === DEFAULT_ACCOUNTS[1] ||
              typeAccount === DEFAULT_ACCOUNTS[2] ||
              typeAccount === DEFAULT_ACCOUNTS[3]
            }
            ref={btnActionRef}
            type="button"
            className="btn-primary"
            onClick={() => handleSubmitLineal()}
          >
            Crear cuenta (Modo Pruebas UI)
          </button> */}
        </div>
        <p ref={error2EmailRef} className="error-txt bounce action-error">
          Lo siento, estamos experimentando problemas técnicos. Por favor, inténtenlo de nuevo más
          tarde
        </p>
      </div>
      <div ref={processingRef} className="App-loader">
        <img className="img-main2" src="http://cdn.houndsoftware.net/mib/MB-main.svg" alt="" />
        <i className="loader"></i>
      </div>
      <div ref={successedRef} className="App-successed">
        <img className="img-main2" src="http://cdn.houndsoftware.net/mib/MB-main.svg" alt="" />
        <h2 className="title-header">¡Correo enviado!</h2>
        <p className="body-txt">
          {`Podrá acceder al formulario de apertura de cuenta `}
          <strong>{`${getTitle()}`}</strong>
          {` desde el link enviado al correo `}
          <b ref={emailNameRef} className="body-txt"></b>
        </p>
        <div className="flex-row">
          <a href="https://mibanco.com.sv/" className="return-txt">
            Regresar a Mi Banco
          </a>
          <button type="button" onClick={goToHome} className="return-txt">
            Ir a crear otra cuenta
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiBancoDemo;
